import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";

// Table
import {
  bukuBesarTable,
  laporanDetailJurnalBukuBesarTable,
} from "./bukuBesarTable";

// API
import {
  getLaporanBukuBesar,
  getLaporanDetailJurnalBukuBesarByKodeAkun,
} from "./api/bukuBesarAPI";
import { getDropdownUnitUsaha } from "views/admin/masterData/unitUsaha/api/unitUsahaAPI";

// Components
import CardTableBukuBesar from "components/Cards/CardTableBukuBesar";

import jsPDF from "jspdf";
import "jspdf-autotable";
import { CurrencyFormat } from "views/helpers/CurrencyFormat";
import CardTableDetailAkunBukuBesar from "components/Cards/CardTableDetailAkunBukuBesar";

export default function BukuBesar() {
  const tanggalSaatIni = new Date().toISOString().slice(0, 10);
  const tanggalAwalTahun = tanggalSaatIni.slice(0, 5) + "01-01";

  const [formData, setFormData] = useState({
    tanggal_awal: tanggalAwalTahun,
    tanggal_akhir: tanggalSaatIni,
  });

  const [dataTable, setDataTable] = useState([]);
  const [dataInput, setDataInput] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);

  // Select-Option Data
  const [dropdownUnitUsaha, setDropdownUnitUsaha] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [errors, setErrors] = useState(null);

  const [isExportable, setIsExportable] = useState(false);

  const [checkDetailAkun, setCheckDetailAkun] = useState(false);

  // Loading
  useEffect(() => {
    if (isLoading === true) {
      toast.loading("Data Diproses..");
    } else {
      toast.dismiss();
    }
  }, [isLoading]);

  // Handle when Page Change
  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  // Set Inputted Data to Form
  const setData = (key, value) => {
    console.log(formData);
    return setFormData({ ...formData, [key]: value });
  };

  // Load Dropdown Kode Akun
  useEffect(() => {
    setIsLoading(true);

    getDropdownUnitUsaha()
      .then((response) => {
        setDropdownUnitUsaha(response.data.data);
      })
      .catch((err) => setErrors(err))
      .finally(setIsLoading(false));

    return () => {
      setDropdownUnitUsaha([]);
    };
  }, []);

  const handleGetLaporanBukuBesar = (e) => {
    e.preventDefault();
    setIsLoading(true);

    getLaporanBukuBesar(formData)
      .then((response) => setResult(response))
      .catch((err) => setErrors(err))
      .finally(() => endSubmitProcess());
  };

  // Handle when submit process end
  const endSubmitProcess = () => {
    setIsLoading(false);
  };

  // Check if request failed
  useEffect(() => {
    if (errors !== null) {
      toast.error(errors.message);
    }
  }, [errors]);

  // Check if request success
  useEffect(() => {
    if (result !== null) {
      if (result.data.success === true) {
        toast.success(result.data.message);
        setDataTable(result.data.data.dataTransaksi);
        setDataInput(result.data.data.dataInput);
        setIsExportable(true);
        setPageNumber(0);
      } else {
        setIsExportable(false);
        let numericArray = [];
        for (let err in result.data.errors) {
          numericArray.push(result.data.errors[err]);
        }

        if (numericArray.length > 0) {
          toast.error(numericArray[0]);
        }
      }
    }
    setResult(null);
  }, [result]);

  // EXPORT PDF
  const exportPDF = () => {
    const unit = "pt";
    const size = "A4";
    const orientation = "landscape";

    const marginLeft = 20;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(15);

    const title = `Buku Besar (${dataInput.tanggal_awal} s/d ${dataInput.tanggal_akhir})`;
    const headers = [
      [
        "Kode Akun",
        "Nama Akun",
        "Saldo Awal",
        "Debet",
        "Kredit",
        "Saldo Akhir",
      ],
    ];

    const data = dataTable.map((elt) => [
      elt.kode_akun,
      elt.nama_akun,
      CurrencyFormat(elt.saldo_awal),
      CurrencyFormat(elt.debet),
      CurrencyFormat(elt.kredit),
      CurrencyFormat(elt.saldo_akhir),
    ]);

    let content = {
      startY: 50,
      head: headers,
      body: data,
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save("BukuBesar.pdf");
  };

  // Handle Detail Kode Akun
  const handleCheckDetailAkun = (kodeAkun) => {
    const detailAkunFormData = {
      tanggal_awal: formData.tanggal_awal,
      tanggal_akhir: formData.tanggal_akhir,
      kode_akun: kodeAkun,
    };
    if (kodeAkun !== null) {
      getLaporanDetailJurnalBukuBesarByKodeAkun(detailAkunFormData)
        .then((response) => {
          setResult(response);
        })
        .catch((err) => setErrors(err))
        .finally(() => endSubmitProcess());

      setCheckDetailAkun(true);
    }
  };

  const handleCloseCheckDetailAkun = () => {
    getLaporanBukuBesar(formData)
      .then((response) => setResult(response))
      .catch((err) => setErrors(err))
      .finally(() => endSubmitProcess());
    setCheckDetailAkun(false);
  };

  if (checkDetailAkun === true) {
    return (
      <div>
        <div className="flex flex-wrap mt-4">
          <div className="w-full mb-12 px-4">
            <Toaster />
            <CardTableDetailAkunBukuBesar
              tableTitle="Detail Akun"
              cols={laporanDetailJurnalBukuBesarTable()}
              data={dataTable}
              pageNumber={pageNumber}
              changePage={changePage}
              handleCloseCheckDetailAkun={handleCloseCheckDetailAkun}
              exportToExcel={true}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="flex flex-wrap mt-4">
        <div className="w-full mb-12 px-4">
          <Toaster />
          <CardTableBukuBesar
            tableTitle="Buku Besar"
            cols={bukuBesarTable(handleCheckDetailAkun)}
            data={dataTable}
            pageNumber={pageNumber}
            changePage={changePage}
            handleSubmit={handleGetLaporanBukuBesar}
            setData={setData}
            exportPDF={exportPDF}
            isExportable={isExportable}
            unitUsahaDropdown={dropdownUnitUsaha}
          />
        </div>
      </div>
    </div>
  );
}
